import templateDefaults from '../templateDefaults';

const TGB_ASSETS_URL = process.env.TGB_ASSETS_CDN_URL;

export default {
  previewImage: '/img/sports/player-side-slab.png',
  title: 'Side Slab',
  templateData() {
    return {
      version: 'v1.1',
      title: 'Player Side Slab',
      ...templateDefaults,
      elements: [
        {
          version: 'v1',
          type: 'image',
          name: 'Player Headshot',
          editable: true,
          locked: false,
          aspectLock: true,
          mask: false,
          maskShape: 'oval',
          imageUrl: `${TGB_ASSETS_URL}/placeholders/player-headshot.png`,
          cssClasses: '',
          animation: true,
          animationInStyle: 'slideInUp',
          animationInDuration: 500,
          animationInDelay: 500,
          animationInEasing: '0.455, 0.030, 0.515, 0.955',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          fillType: 'stretch',
          border: false,
          borderWidth: 2,
          borderColor: '#000000',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          styles: {
            top: 95,
            left: 270,
            width: 307,
            height: 343,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'image',
          name: 'flare-2.png',
          editable: true,
          locked: false,
          aspectLock: true,
          mask: false,
          maskShape: 'oval',
          imageUrl: `${TGB_ASSETS_URL}/placeholders/flare-2.png`,
          cssClasses: '',
          animation: true,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 2000,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          fillType: 'stretch',
          border: false,
          borderWidth: 2,
          borderColor: '#000000',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          styles: {
            top: 529,
            left: 617,
            width: 233,
            height: 427,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Text',
          locked: false,
          text: '<p><strong>A.L. ROOKIE OF THE YEAR</strong></p><p>\t2008</p><p><br></p><p><strong>5-time all-star</strong></p><p>\t2-time gold glove</p><p><br></p><p><strong>3-time world champion</strong></p><p>\t2018 world series mvp</p>',
          cssClasses: '',
          animation: true,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 1500,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ellipsis: true,
          whiteSpace: 'normal',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 573,
            left: 160,
            width: 490,
            height: 394,
            opacity: 1,
            color: 'rgb(255, 255, 255)',
            fontFamily: 'Roboto Condensed',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontSize: 35,
            fontWeight: 'normal',
            fontStyle: 'normal',
            letterSpacing: 0,
          },
          fitText: true,
        },
        {
          version: 'v1',
          type: 'rectangle',
          name: 'Rectangle',
          locked: false,
          aspectLock: false,
          cssClasses: '',
          animation: true,
          animationInStyle: 'fadeInRight',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.785, 0.135, 0.150, 0.860',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          border: true,
          borderWidth: 8,
          borderColor: 'rgb(255, 255, 255)',
          boxShadow: true,
          boxShadowX: 0,
          boxShadowY: 0,
          boxShadowBlur: 5,
          boxShadowSpread: 2,
          boxShadowColor: 'rgba(255, 255, 255, 0.4)',
          fillStyle: 'solid',
          backgroundColor: 'rgb(8, 29, 69)',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          backgroundImage: false,
          backgroundImageUrl: '',
          borderTopLeftRadius: 15,
          borderTopRightRadius: 15,
          borderBottomRightRadius: 15,
          borderBottomLeftRadius: 15,
          blur: false,
          blurSize: 10,
          skewX: 0,
          skewY: 0,
          rotate: 0,
          styles: {
            top: 535,
            left: 120,
            width: 616,
            height: 476,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Text',
          locked: false,
          text: '<p>SS</p>',
          cssClasses: '',
          animation: true,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 1000,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ellipsis: true,
          whiteSpace: 'normal',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 474,
            left: 649,
            width: 76,
            height: 35,
            opacity: 1,
            color: 'rgb(255, 255, 255)',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto","Helvetica Neue", Arial, sans-serif',
            textTransform: 'none',
            textDecoration: 'none',
            fontSize: 28,
            fontWeight: 'normal',
            fontStyle: 'normal',
            letterSpacing: 0,
          },
          fitText: true,
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Text',
          locked: false,
          text: '<p>7</p>',
          cssClasses: '',
          animation: true,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 1000,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ellipsis: true,
          whiteSpace: 'normal',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 466,
            left: 133,
            width: 76,
            height: 50,
            opacity: 1,
            color: 'rgb(255, 255, 255)',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto","Helvetica Neue", Arial, sans-serif',
            textTransform: 'none',
            textDecoration: 'none',
            fontSize: 45,
            fontWeight: 'normal',
            fontStyle: 'normal',
            letterSpacing: 0,
          },
          fitText: true,
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Text',
          locked: false,
          text: '<p class="ql-align-center"><strong>PLAYER NAME</strong></p>',
          cssClasses: '',
          animation: true,
          animationInStyle: 'fadeIn',
          animationInDuration: 500,
          animationInDelay: 1000,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ellipsis: true,
          whiteSpace: 'normal',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 467,
            left: 191,
            width: 446,
            height: 50,
            opacity: 1,
            color: 'rgb(255, 255, 255)',
            fontFamily: 'Roboto Condensed',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontSize: 45,
            fontWeight: 'normal',
            fontStyle: 'normal',
            letterSpacing: 0,
          },
          fitText: true,
        },
        {
          version: 'v1',
          type: 'rectangle',
          name: 'Rectangle',
          locked: false,
          aspectLock: false,
          cssClasses: '',
          animation: true,
          animationInStyle: 'fadeInLeft',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.785, 0.135, 0.150, 0.860',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          border: true,
          borderWidth: 8,
          borderColor: 'rgb(255, 255, 255)',
          boxShadow: true,
          boxShadowX: 0,
          boxShadowY: 0,
          boxShadowBlur: 5,
          boxShadowSpread: 2,
          boxShadowColor: 'rgba(255, 255, 255, 0.4)',
          fillStyle: 'solid',
          backgroundColor: 'rgb(0, 0, 0)',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          backgroundImage: false,
          backgroundImageUrl: '',
          borderTopLeftRadius: 15,
          borderTopRightRadius: 15,
          borderBottomRightRadius: 15,
          borderBottomLeftRadius: 15,
          blur: false,
          blurSize: 10,
          skewX: 20,
          skewY: 0,
          rotate: 0,
          styles: {
            top: 451,
            left: 104,
            width: 616,
            height: 80,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'image',
          name: 'team-logo-skew.png',
          editable: true,
          locked: false,
          aspectLock: true,
          mask: false,
          maskShape: 'oval',
          imageUrl: `${TGB_ASSETS_URL}/placeholders/team-logo-skew.png`,
          cssClasses: '',
          animation: true,
          animationInStyle: 'popIn',
          animationInDuration: 500,
          animationInDelay: 1000,
          animationInEasing: '0.680, -0.550, 0.265, 1.550',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          fillType: 'stretch',
          border: false,
          borderWidth: 2,
          borderColor: '#000000',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          styles: {
            top: 220,
            left: 225,
            width: 448,
            height: 233,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'rectangle',
          name: 'Rectangle',
          locked: false,
          aspectLock: false,
          cssClasses: '',
          animation: true,
          animationInStyle: 'fadeInRight',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.785, 0.135, 0.150, 0.860',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          border: true,
          borderWidth: 8,
          borderColor: 'rgb(255, 255, 255)',
          boxShadow: true,
          boxShadowX: 0,
          boxShadowY: 0,
          boxShadowBlur: 5,
          boxShadowSpread: 2,
          boxShadowColor: 'rgba(255, 255, 255, 0.4)',
          fillStyle: 'solid',
          backgroundColor: 'rgb(0, 116, 74)',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          backgroundImage: false,
          backgroundImageUrl: '',
          borderTopLeftRadius: 15,
          borderTopRightRadius: 15,
          borderBottomRightRadius: 15,
          borderBottomLeftRadius: 15,
          blur: false,
          blurSize: 10,
          skewX: -20,
          skewY: 0,
          rotate: 0,
          styles: {
            top: 199,
            left: 136,
            width: 618,
            height: 248,
            opacity: 1,
          },
        },
      ],
    };
  },
};
